import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './assets/styles/index.css';

// Configure axios default settings for API calls
import axios from 'axios';

// Set base URL for API calls
// Don't set a global base URL - rely on Vite's proxy configuration instead
// When a route starts with '/api', it will be proxied to http://localhost:5000
// When a route starts with '/cxf', it will be proxied to http://localhost:8080
// axios.defaults.baseURL = 'http://localhost:8080';
// axios.defaults.baseURL = 'https://api.rss.solar';

// Configure axios to include credentials in requests (for cookies)
axios.defaults.withCredentials = true;

// Make sure the root element is targeted correctly
const rootElement = document.getElementById('root');

if (!rootElement) {
  console.error('Failed to find the root element');
} else {
  ReactDOM.createRoot(rootElement).render(
    <App />
  );
} 